import type { ReactNode } from 'react';
import { ChevronIcon } from '@/assets/icons';
import styles from './SettingsList.module.scss';

export function SettingsGroup({ children }: { children: ReactNode }) {
  return <div className={styles.group}>{children}</div>;
}

export interface SettingsRowProps {
  label: string;
  onClick?: () => void;
}

export function SettingsRow({ label, onClick }: SettingsRowProps) {
  return (
    <button type="button" className={styles.row} onClick={onClick}>
      <span className={styles.label}>{label}</span>
      <ChevronIcon size={16} className={styles.chevron} />
    </button>
  );
}
